const getStorage = () => {
	try {
		return localStorage;
	} catch {
		return sessionStorage;
	}
};

export const storage = getStorage();
